// DUET — two-column accordion. The classic accordion split into two tidy
// columns (items alternate left/right) so long FAQs stay above the fold.
// Hairline dividers per column, compact 16px questions.
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span>${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const duet = {
    id: 'duet',
    name: 'Duet',
    tag: 'Two-column accordion',
    styleTag: 'Compact',
    description: 'The classic accordion, halved in height. Two tidy columns keep long FAQs above the fold without feeling dense \u2014 ideal for footers and pricing pages.',
    layout: 'accordion',
    defaultAccent: '#0e8f7e',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion'],
    render(ctx) {
        const colA = ctx.items.filter((_, i) => i % 2 === 0);
        const colB = ctx.items.filter((_, i) => i % 2 === 1);
        const col = (items) => `<div class="fq-col">
${items.map((it) => itemHtml(ctx, it)).join('\n')}
</div>`;
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-grid">
${col(colA)}
${col(colB)}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:920px;margin:0 auto}
.FQM .fq-title{margin:0 0 10px;font-family:${ctx.v.head};font-size:34px;font-weight:600;line-height:1.12;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 26px;font-size:16px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:0 44px;align-items:start}
.FQM .fq-col{border-top:1px solid ${ctx.v.border}}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 2px;font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 30px 18px 2px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default duet;
